import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCornerRadius: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCornerRadius"><Path d="M21 3V4.5H4.5V21H3V3H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCornerRadius;
